import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import axios from './axios.js' // Use our configured axios
import axiosPlugin from './plugins/axios.js'
import './style.css'
import App from './App.vue'
import { activeUiTemplateId } from './ui-template'

const startApp = (Root) => {
  const app = createApp(Root)
  app.use(createPinia())
  app.use(router)
  app.use(axiosPlugin) // Use our axios plugin

  // Make our configured axios available globally
  app.config.globalProperties.$axios = axios

  app.mount('#app')
}

// In the client view window
window.addEventListener('message', (event) => {
  if (event.origin === window.location.origin &&
      event.data.type === 'INIT_CLIENT_VIEW') {
    // Set up client view with admin privileges
    const { token, role } = event.data
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    axios.defaults.headers.common['X-Viewing-As'] = role
  }
})

// Interface template is picked once per page load (src/ui-template). The new
// template's shell is only fetched when it is the active one.
if (activeUiTemplateId === 'next') {
  import('./next/NextApp.vue').then(({ default: NextApp }) => startApp(NextApp))
} else {
  startApp(App)
}
